import { InjectionToken } from '@angular/core';
import { DataPackage, Schema } from '@apis/cas/generated';

export const CAS_DATA_SERVICE = new InjectionToken<ICasDataService>('cas data service provider');

export interface ICasDataService {
  getSchema(): Promise<Schema>;
  getDataPackage(): Promise<DataPackage>;
  getDataPackageVersion(): Promise<string>;
}
